import { getAbTestV2 } from 'dibs-buyer-layout/exports/clientABTestV2';
import { AbTestV2Func } from 'dibs-buyer-layout/exports/serverABTestV2';

export const BEST_SELLERS_COLLECTION = 'bestSellersCollection' as const;
export const PERSONALIZED_RERANK_TEST_NAME = 'Personalized-Rerank' as const;
export const SPONSORED_LISTINGS_TEST_NAME = 'sponsored-listings' as const;
export const ITEM_TILE_SHORTER_HEIGHT = 'ItemTileShorterHeight' as const;
export const NET_PRICE_15_FILTER_TEST_NAME = 'NetPrice15Filter' as const;

export const isPersonalizedRerankAbTestVariantOrControl = (): boolean =>
    !!getAbTestV2(PERSONALIZED_RERANK_TEST_NAME)?.variant;

export const isSponsoredListingVariant = (): boolean =>
    getAbTestV2(SPONSORED_LISTINGS_TEST_NAME)?.variant === 'variant';

export const isSponsoredListingVariantOrControl = (): boolean =>
    !!getAbTestV2(SPONSORED_LISTINGS_TEST_NAME)?.variant;

export const isItemTileShorterHeightVariantServer = (getAbTestV2Server: AbTestV2Func): boolean =>
    getAbTestV2Server(ITEM_TILE_SHORTER_HEIGHT)?.variant === 'variant';
